module.exports = __webpack_public_path__ + "img/edge.c4574665.svg";